import { upperFirst as _upperFirst } from 'lodash-es';

export default function upperFirst(text) {
  return _upperFirst(text.toLowerCase());
}
